import axios from "axios";
import {pushToast} from "../utils/pushToast";

const apiUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_KEY : process.env.REACT_APP_DEV_API_KEY;

const client = axios.create({
    baseURL: apiUrl,
})

client.defaults.headers.common.Accept = 'application/json';
client.defaults.headers.common['Accept-Language'] = "fa";
client.defaults.headers.common['Content-Type'] = 'application/json';
client.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
client.interceptors.request.use(request => {
    return request;
})

client.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status === 401) {
        removeToken();
        window.location.replace("/login")
    }
    if (error.response.status === 403) {
        pushToast("خطای دسترسی", "error")
    }
    return Promise.reject(error)
})

export const setToken = (token) => {
    localStorage.setItem('token', token);
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const removeToken = () => {
    localStorage.removeItem('token');
    client.defaults.headers.common['Authorization'] = "";
}

export const login = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const {data} = await client.post(`Authentication/LoginUser`, values);
    return data;
}

export const me = async () => {
    const {data} = await client.post(`User/UserInfo`);
    return data;
}

export const logout = async (values) => {
    const {data} = await client.post(`Authentication/Logout`, values);
    removeToken();
    return data;
}

export const register = (values) => {
    const {data} = client.post(`Authentication/RegisterUser`, values);
    setToken(data.token);
    return data;
}
export const AddMobileData = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const {data} = await client.post(`Authentication/AddMobileData`,values);
    return data;
}

export const AddMobileData2 = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const {data} = await client.post(`Public/AddMobileData2`,values);
    return data;
}

export const forgetPassword = (values) => {
    const {data} = client.post(`forget-password`, values);
    return data;
}

export const resetPassword = (values) => {
    const {data} = client.post(`reset-password`, values);
    return data;
}

export const verifyEmail = () => {
    const {data} = client.get(`verify-email`);
    return data;
}


// common

export const languages = async () => {
    const {data} = await client.get(`Common/GetListLanguage`);
    return data;
}

// User
export const users = async (values) => {
    const {data} = await client.post(`User/UserList`, values);
    return data;
}
export const UserListWithSpeceficRole = async (values) => {
    const {data} = await client.post(`User/UserListWithSpeceficRole`, values);
    return data;
}


export const user = async (id) => {
    const {data} = await client.get(`User/UserItem/${id}`);
    return data;
}

export const createUser = async (values) => {
    const {data} = await client.post(`User/AddNewUser`, values)
    return data;
}

export const updateUser = async (id, values) => {
    const {data} = await client.patch(`User/EditUser/${id}`, values)
    return data;
}
export const uploadExcelFile = async ( values) => {
    const {data} = await client.post(`User/UploadExcelFile`, values)
    return data;
}
export const deleteUser = async (id) => {
    const {data} = await client.delete(`User/RemoveUser/${id}`)
    return data;
}

export const updateUserRole = async (values) => {
    const {data} = await client.patch(`User/UpdateUserRole`, values)
    return data;
}

// permission category

export const permissionCategories = async (values) => {
    const {data} = await client.post(`PermissionCategory/PermissionCategoryList`, values);
    return data;
}

export const permissionCategory = async (id) => {
    const {data} = await client.get(`PermissionCategory/PermissionCategoryItem/${id}`);
    return data;
}

export const createPermissionCategory = async (values) => {
    const {data} = await client.post(`PermissionCategory/AddPermissionCategory`, values);
    return data;
}

export const deletePermissionCategory = async (id) => {
    const {data} = await client.delete(`PermissionCategory/RemovePermissionCategory/${id}`);
    return data;
}

export const updatePermissionCategory = async (id, values) => {
    const {data} = await client.patch(`PermissionCategory/EditPermissionCategory/${id}`, values);
    return data;
}

export const permissionCategoryList = async () => {
    const {data} = await client.get(`Permission/GetPermissionWithCategoryList`);
    return data;
}

// Role
export const roles = async (values) => {
    const {data} = await client.post(`Role/RoleList`, values);
    return data;
}

export const role = async (id) => {
    const {data} = await client.get(`Role/GetRoleItem/${id}`);
    return data;
}

export const createRole = async (values) => {
    const {data} = await client.post(`Role/AddRole`, values);
    return data;
}

export const deleteRole = async (id) => {
    const {data} = await client.delete(`Role/RemoveRole/${id}`);
    return data;
}

export const updateRole = async (id, values) => {
    const {data} = await client.patch(`Role/EditRole/${id}`, values);
    return data;
}

export const updateRolePermission = async (values) => {
    const {data} = await client.patch(`Role/UpdateRolePermission`, values);
    return data;
}

//permission
export const permissions = async (values) => {
    const {data} = await client.post(`Permission/PermissionList`, values);
    return data;
}

export const permission = async (id) => {
    const {data} = await client.get(`Permission/GetPermissionItem/${id}`);
    return data;
}

export const createPermission = async (values) => {
    const {data} = await client.post(`Permission/AddPermission`, values)
    return data;
}

export const deletePermission = async (id) => {
    const {data} = await client.delete(`Permission/RemovePermission/${id}`);
    return data;
}

export const updatePermission = async (id, values) => {
    const {data} = await client.patch(`Permission/EditPermission/${id}`, values);
    return data;
}


//ServiceCategory
export const serviceCategories = async (values) => {
    const {data} = await client.post(`ServiceCategory/ServiceCategoryList`, values);
    return data;
}
export const allServiceCategories = async () => {
    const {data} = await client.get(`ServiceCategory/AllServiceCategoryList`);
    return data;
}
export const serviceCategory = async (id) => {
    const {data} = await client.get(`ServiceCategory/ServiceCategoryItem/${id}`);
    return data;
}
export const deleteServiceCategory = async (id) => {
    const {data} = await client.delete(`ServiceCategory/RemoveServiceCategory/${id}`);
    return data;
}
export const createServiceCategory = async (values) => {
    const {data} = await client.post(`ServiceCategory/AddServiceCategory`, values);
    return data;
}
export const updateServiceCategory = async (id, values) => {
    const {data} = await client.patch(`ServiceCategory/EditServiceCategory/${id}`, values);
    return data;
}

//ServiceStatus
export const serviceStatuses = async (values) => {
    const {data} = await client.post(`ServiceStatus/ServiceStatusList`, values);
    return data;
}
export const allServiceStatuses = async () => {
    const {data} = await client.get(`ServiceStatus/AllServiceStatusList`);
    return data;
}
export const serviceStatus = async (id) => {
    const {data} = await client.get(`ServiceStatus/ServiceStatusItem/${id}`);
    return data;
}
export const deleteServiceStatus = async (id) => {
    const {data} = await client.delete(`ServiceStatus/RemoveServiceStatus/${id}`);
    return data;
}
export const createServiceStatus = async (values) => {
    const {data} = await client.post(`ServiceStatus/AddServiceStatus`, values);
    return data;
}
export const updateServiceStatus = async (id, values) => {
    const {data} = await client.patch(`ServiceStatus/EditServiceStatus/${id}`, values);
    return data;
}


//ServiceType
export const serviceTypes = async (values) => {
    const {data} = await client.post(`ServiceType/ServiceTypeList`, values);
    return data;
}
export const allServiceTypes = async () => {
    const {data} = await client.get(`ServiceType/AllServiceTypeList`);
    return data;
}
export const serviceType = async (id) => {
    const {data} = await client.get(`ServiceType/ServiceTypeItem/${id}`);
    return data;
}
export const deleteServiceType = async (id) => {
    const {data} = await client.delete(`ServiceType/RemoveServiceType/${id}`);
    return data;
}
export const createServiceType = async (values) => {
    const {data} = await client.post(`ServiceType/AddServiceType`, values);
    return data;
}
export const updateServiceType = async (id, values) => {
    const {data} = await client.patch(`ServiceType/EditServiceType/${id}`, values);
    return data;
}

//Service

export const services = async (values) => {
    const {data} = await client.post(`Service/ServiceList`, values);
    return data;
}

export const service = async (id) => {
    const {data} = await client.get(`Service/ServiceItem/${id}`);
    return data;
}
export const deleteService = async (id) => {
    const {data} = await client.delete(`Service/RemoveService/${id}`);
    return data;
}
export const createService = async (values) => {
    const {data} = await client.post(`Service/AddService`, values);
    return data;
}
export const createServiceWithServiceMan = async (values) => {
    const {data} = await client.post(`Service/AddServiceWithServiceMan`, values);
    return data;
}
export const updateService = async (id, values) => {
    const {data} = await client.patch(`Service/EditService/${id}`, values);
    return data;
}
export const userListWithRole = async (values) => {
    const {data} = await client.post(`User/UserListWithRole`, values);
    return data;
}
export const ReportAllService = async () => {
    const {data} = await client.get(`Service/ReportAllService`);
    return data;
}
export const ReportUserService = async () => {
    const {data} = await client.get(`Service/ReportUserService`);
    return data;
}
//ServiceMan
export const ServiceManServiceItem = async (id) => {
    const {data} = await client.get(`Service/ServiceManServiceItem/${id}`);
    return data;
}
export const AssistantServiceItem = async (id) => {
    const {data} = await client.get(`Service/AssistantServiceItem/${id}`);
    return data;
}
export const UpdateServiceWithServiceMan = async (id, values) => {
    const {data} = await client.patch(`Service/EditServiceWithServiceMan/${id}`, values);
    return data;
}
export const ServiceManServiceList = async (values) => {
    const {data} = await client.post(`Service/ServiceManServiceList`, values);
    return data;
}
export const getAllService = async () => {
    const {data} = await client.get(`Service/GetAllServiceList`);
    return data;
}
export const GetAllServiceListForServiceMan = async () => {
    const {data} = await client.get(`Service/GetAllServiceListForServiceMan`);
    return data;
}
export const ServiceManPrice = async () => {
    const {data} = await client.get(`Service/ServiceManPrice`);
    return data;
}
export const AssistantServiceList = async (values) => {
    const {data} = await client.post(`Service/AssistantServiceList`, values);
    return data;
}
//City

export const cities = async (values) => {
    const {data} = await client.post(`City/CityList`, values);
    return data;
}
export const city = async (id) => {
    const {data} = await client.get(`City/CityItem/${id}`);
    return data;
}
export const deleteCity = async (id) => {
    const {data} = await client.delete(`City/RemoveCity/${id}`);
    return data;
}
export const createCity = async (values) => {
    const {data} = await client.post(`City/AddCity`, values);
    return data;
}
export const updateCity = async (id, values) => {
    const {data} = await client.patch(`City/EditCity/${id}`, values);
    return data;
}
export const AllCity = async (id) => {
    const {data} = await client.get(`City/AllCityList/${id}`);
    return data;
}
export const UserAccessCityList = async () => {
    const {data} = await client.get(`User/UserAccessCityList`);
    return data;
}
export const UserAccessServiceCategoryList = async () => {
    const {data} = await client.get(`User/UserAccessServiceCategoryList`);
    return data;
}
export const UserAccessServiceCategoryListWithId = async (id) => {
    const {data} = await client.get(`User/UserAccessServiceCategoryList/${id}`);
    return data;
}
//State

export const states = async (values) => {
    const {data} = await client.post(`State/StateList`, values);
    return data;
}
export const stateInfo = async (id) => {
    const {data} = await client.get(`State/StateItem/${id}`);
    return data;
}
export const deleteState = async (id) => {
    const {data} = await client.delete(`State/RemoveState/${id}`);
    return data;
}
export const createState = async (values) => {
    const {data} = await client.post(`State/AddState`, values);
    return data;
}
export const updateState = async (id, values) => {
    const {data} = await client.patch(`State/EditState/${id}`, values);
    return data;
}
export const AllState = async () => {
    const {data} = await client.post(`State/AllStateList`);
    return data;
}
//CommissionLevel

export const commissionLevels = async (values) => {
    const {data} = await client.post(`CommissionLevel/CommissionLevelList`, values);
    return data;
}
export const allCommissionLevels = async (values) => {
    const {data} = await client.post(`CommissionLevel/AllCommissionLevelList`, values);
    return data;
}
export const commissionLevel = async (id) => {
    const {data} = await client.get(`CommissionLevel/CommissionLevelItem/${id}`);
    return data;
}
export const deleteCommissionLevel = async (id) => {
    const {data} = await client.delete(`CommissionLevel/RemoveCommissionLevel/${id}`);
    return data;
}
export const createCommissionLevel = async (values) => {
    const {data} = await client.post(`CommissionLevel/AddCommissionLevel`, values);
    return data;
}
export const updateCommissionLevel = async (id, values) => {
    const {data} = await client.patch(`CommissionLevel/EditCommissionLevel/${id}`, values);
    return data;
}

export const SaveToken = async (values) => {
    const {data} = await client.post(`Notification/SaveFirebaseToken`,values);
    return data;
}


//public
export const AllServiceTypeListPublic = async () => {
    const {data} = await client.get(`Public/AllServiceTypeList`);
    return data;
}
export const AllServiceCategoryListPublic = async () => {
    const {data} = await client.get(`Public/AllServiceCategoryList/`);
    return data;
}
export const AllCityPublic = async (id) => {
    const {data} = await client.get(`Public/AllCityList/${id}`);
    return data;
}
export const AllStatePublic = async () => {
    const {data} = await client.post(`Public/AllStateList`);
    return data;
}